import { createContext, ReactElement, ReactNode, useContext } from 'react'

import { Account } from '@modules-deprecated/app/accounts/types'

import { useUpdateAccountFromTemplateModal } from '../hooks/useUpdateAccountFromTemplateModal'

type ContextState = ReturnType<typeof useUpdateAccountFromTemplateModal>

const UpdateAccountFromTemplateFormContext = createContext<ContextState | undefined>(undefined)

interface UpdateAccountFromTemplateFormContextProviderProps {
  account?: Account
  children: ReactNode
  onClose?: () => void
  onSave?: () => void
}

export const UpdateAccountFromTemplateFormContextProvider = ({
  account,
  children,
  onClose,
  onSave,
}: UpdateAccountFromTemplateFormContextProviderProps): ReactElement => {
  const contextValue = useUpdateAccountFromTemplateModal({ account, onClose, onSave })

  return (
    <UpdateAccountFromTemplateFormContext.Provider value={contextValue}>
      {children}
    </UpdateAccountFromTemplateFormContext.Provider>
  )
}

export const useUpdateAccountFromTemplateForm = (): ContextState => {
  const context = useContext(UpdateAccountFromTemplateFormContext)

  if (!context) {
    throw new Error('UpdateAccountFromTemplateFormContextProvider is missing in the module!')
  }

  return context
}
